import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import ROUTES, { QUOTATION_FLOW_ROUTES_VALIDATION } from "../constants/routes";
import { getPathWithPartner } from "../libs/helpers/location";

const QuotationFlowRoute = ({ path, systemPath, partner, partnerType, ...rest }) => {
    const state = useSelector(store => store);
    const {
        Page: { queryString },
    } = state;
    const validationConfiguration =
        QUOTATION_FLOW_ROUTES_VALIDATION.HOME_INSURANCE[systemPath];
    if (!validationConfiguration) {
        return <Redirect to={ROUTES.HOME_INSURANCE._MAIN} />;
    }
    const { validate, onEnter, redirectPath } = validationConfiguration;

    if (validate(state)) {
        onEnter && onEnter();
        return <Route path={path} {...rest} />;
    }
    const redirectPathPartner = getPathWithPartner(redirectPath, partner, partnerType);
    return <Redirect to={{ pathname: redirectPathPartner, search: queryString }} />;
};

export default QuotationFlowRoute;
